import http from 'shared/utils/http';

export const fetchEdiLogTblData = (params) => {
  return http.get('/edi/log', params);
};
